module.exports = __webpack_public_path__ + "static/media/HCMM429.a3cb83aa.jpg";